export const QUANTITY_OPTIONS = [20, 50, 200];
export const MIN_SIZES_SELECTED = 40;

export const TIRE_CATEGORIES = [
  {
    id: 'passenger-small',
    label: '13"–16" Passenger',
    rimRange: '13" – 16"',
    sizes: [
      '175/65R13', '185/55R14', '165/60R14', '185/60R14', '155/65R14', '165/65R14',
      '205/50R15', '175/55R15', '185/55R15', '195/55R15', '205/55R15', '155/60R15', '165/60R15',
      '175/60R15', '185/60R15', '205/60R15', '145/65R15', '155/65R15', '165/65R15', '175/65R15',
      '185/65R15', '195/65R15', '225/50R16', '185/55R16', '195/55R16', '205/55R16', '225/55R16',
      '195/60R16', '205/60R16', '215/60R16', '225/60R16', '235/60R16', '195/65R16', '205/65R16',
      '215/65R16', '225/65R16', '195/45R16', '205/45R16', '215/45R16', '185/50R16', '195/50R16',
    ],
  },
  {
    id: 'passenger-mid',
    label: '17"–19" Passenger',
    rimRange: '17" – 19"',
    sizes: [
      '275/50R17', '215/55R17', '225/55R17', '235/55R17', '275/55R17', '215/60R17', '225/60R17',
      '275/60R17', '215/65R17', '225/65R17', '235/65R17', '245/65R17', '255/65R17', '265/65R17',
      '205/40R17', '215/40R17', '225/40R17', '235/40R17', '245/40R17', '255/40R17', '275/40R17',
      '215/45R17', '225/45R17', '235/45R17', '245/45R17', '205/50R17', '215/50R17', '225/50R17',
      '235/50R17', '215/30R18', '215/35R18', '245/35R18', '255/35R18', '265/35R18', '275/35R18',
      '215/40R18', '225/40R18', '235/40R18', '245/40R18', '255/40R18', '265/40R18', '275/40R18',
      '215/45R18', '225/45R18', '235/45R18', '245/45R18', '255/45R18', '215/50R18', '225/50R18',
      '235/50R18', '245/50R18', '215/55R18', '235/55R18', '245/55R18', '225/60R18', '245/60R18',
      '255/30R19', '265/30R19', '275/30R19', '285/30R19', '215/35R19', '225/35R19', '235/35R19',
      '245/35R19', '255/35R19', '265/35R19', '275/35R19', '285/35R19', '225/40R19', '235/40R19',
      '245/40R19', '225/45R19', '235/45R19', '245/45R19', '255/45R19', '285/45R19', '225/50R19',
      '235/50R19', '245/50R19', '255/50R19', '275/55R19',
    ],
  },
  {
    id: 'performance-suv',
    label: '20"–22" Performance / SUV',
    rimRange: '20" – 22"',
    sizes: [
      '255/30R20', '265/30R20', '275/30R20', '285/30R20', '295/30R20', '305/30R20', '225/35R20',
      '235/35R20', '245/35R20', '265/35R20', '275/35R20', '285/35R20', '295/35R20', '315/35R20',
      '235/40R20', '245/40R20', '255/40R20', '265/40R20', '275/40R20', '285/40R20', '235/45R20',
      '245/45R20', '255/45R20', '265/45R20', '285/45R20', '295/45R20', '245/50R20', '255/50R20',
      '265/50R20', '275/50R20', '285/50R20', '255/55R20', '275/55R20', '245/60R20', '265/30R21',
      '275/30R21', '245/35R21', '255/35R21', '265/35R21', '275/35R21', '285/35R21', '295/35R21',
      '255/40R21', '275/40R21', '285/40R21', '295/40R21', '305/40R21', '315/40R21', '375/45R21',
      '285/35R22', '265/40R22', '275/40R22', '285/40R22', '295/40R22', '265/45R22',
    ],
  },
  {
    id: 'commercial',
    label: 'Commercial Truck',
    rimRange: '17.5" – 22.5"',
    sizes: [
      '205/75R17.5', '215/75R17.5', '235/75R17.5', '245/70R17.5', '265/70R17.5', '245/70R19.5',
      '265/70R19.5', '285/70R19.5', '275/70R22.5', '295/80R22.5', '315/70R22.5', '315/80R22.5',
      '385/65R22.5',
    ],
  },
];

export const ORDER_TIERS = [
  { quantity: 800, label: '20ft Container', sub: 'Starter Bulk', badge: 'Standard' },
  { quantity: 1600, label: '40ft Container', sub: 'High Volume', badge: 'Most Popular' },
  { quantity: 2400, label: '40ft High-Cube', sub: 'Tripled Density', badge: 'Best Value' },
];
